export { ClickAwayListener as default } from './ClickAwayListener';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/ClickAwayListener/index.js
// module id = 444
// module chunks = 22